module.exports = __webpack_public_path__ + "img/notificationGood.bc2f4717.svg";